<template>
  <div class="event-bag-popup">
    <div class="event-bag-popup-shade"></div>
    <div class="event-bag-popup-content">
      <p class="event-bag-popup-title">{{ letter.awardBag }}</p>
      <p class="event-bag-popup-tip" v-html="letter.seeAwardTip"></p>
      <div class="award-sroll">
        <table class="award-list-table">
          <caption></caption>
          <thead>
            <tr>
              <th>{{ letter.awardName }}</th>
              <th>{{ letter.getTime }}</th>
              <th>{{ letter.getCondition }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in awardLog">
              <template v-if="awardKeyMap[item.key]">
                <td>{{ awardKeyMap[item.key].name }}</td>
                <td>{{ item.time }}</td>
                <td>{{ awardKeyMap[item.key].condition }}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <a class="event-bag-popup-close j-click-bag-close" href="javascript:;" @click="hidePopup"></a>
    </div>
  </div>
</template>

<script type="text/javascript">
import { GET_AWARD_LOG } from '@store/officialStore/event'
const hostname = window.location.hostname;
let arr = hostname.split(".");
export default {
  name: 'eventBagPopup',
  props: [
  ],
  data() {
    return {
      awardKeyMap: {
        1: {
          name: this.$store.state.letter.couponText1,
          condition: this.$store.state.letter.personalRewardText1,
        },
        2: {
          name: this.$store.state.letter.couponText2,
          condition: this.$store.state.letter.personalRewardText2,
        },
        3: {
          name: this.$store.state.letter.couponText3,
          condition: this.$store.state.letter.personalRewardText3,
        },
        4: {
          name: this.$store.state.letter.couponText1,
          condition: this.$store.state.letter.rewardText1,
        },
        5: {
          name: this.$store.state.letter.couponText2,
          condition: this.$store.state.letter.rewardText2,
        },
        6: {
          name: this.$store.state.letter.couponText3,
          condition: this.$store.state.letter.rewardText3,
        },
        7: {
          name: this.$store.state.letter.couponText4,
          condition: this.$store.state.letter.ruleTableContent1,
        },
        8: {
          name: this.$store.state.letter.couponText5,
          condition: this.$store.state.letter.ruleTableContent2,
        },
        10: {
          name: this.$store.state.letter.couponText1,
          condition: this.$store.state.letter.eventInviteSucc,
        },
        11: {
          name: this.$store.state.letter.couponText1,
          condition: this.$store.state.letter.eventSuccBind,
        },
      },
      awardLog: []
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter
    }
  },
  created() {
    this.getAwardLog();
    window.activityDataLayer.push({
      eventName: "click_button",
      eventType: '我的奖励背包',
      aid: "ztmslgpay",
      gameId: 191
    });
  },
  methods: {
    getAwardLog() {
      this.$store.dispatch(GET_AWARD_LOG).then(async res => {
        this.awardLog = res.data;
      }).catch(err => {
        if (+err.code === -20001) {
          window.location.href = `https://pay.${arr[1]}.com/platform/login.html?gameId=191&forward=${encodeURIComponent(window.location.href)}`;
        }
      });
    },
    hidePopup() {
      this.$emit('closeBagPopup')
    },
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';

.event-bag-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
  }

  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 691px;
    height: 561px;
    background-size: 100% 100%;
    transform: translate(-50%, -50%);
    @psetbg ('share-popup-bag.png', false, false);
  }

  &-title {
    position: absolute;
    top: 30px;
    font-size: 44px;
    color: #c1a15e;
    font-weight: 600;
    text-align: center;
    width: 100%;
  }

  &-tip {
    position: absolute;
    top: 90px;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    width: 100%;
  }

  .award-sroll {
    position: absolute;
    top: 145px;
    left: 50%;
    transform: translateX(-50%);
    width: 635px;
    height: 384px;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 4px;
  }

  .award-list-table {
    border-collapse: unset;
    border-spacing: unset;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 384px;
    border: 1px solid var(--event-block-border);

    thead {
      background-color: var(--event-block-border);
      color: var(--event-title);
    }

    tbody {
      display: block;
      width: calc(100% + 4px);
      height: 336px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    tr {
      box-sizing: border-box;
      table-layout: fixed;
      display: table;
      width: 100%;
    }

    td {
      border: 1px solid var(--event-block-border);
      height: 46px;
      text-align: center;
      font-size: 18px;
      color: var(--event-title);
      white-space: pre-wrap;
    }

    th {
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 20px;
      color: var(--event-title);
      white-space: pre-wrap;
      border: none;
    }
  }

  &-close {
    position: absolute;
    right: 31px;
    top: 30px;
    background-size: cover;
    cursor: pointer;
    @psetbg ('close.png');
  }
}
</style>
